import React from 'react';

import Header from '../../components/HeaderNoMenu';
import Button from '../../components/Button'
import { Container, H1, Line, Information, P, Span } from './styles';

export default function TransferSummary() {
    return (
        <>
            <Header />
            <Container>
                <H1>Resumo da transfêrencia</H1>
                <Line></Line>
                <Information>
                    <p className="vivo">Latam pass</p>
                    <P>Transferência programa</P>
                    <p className="pago">100.00 pontos Latam Pass<Span> 1.223<span className="pts">Pts</span></Span></p>
                </Information>
                <Line></Line>
                <P>Total <Span>1.233<span className="pts">Pts</span></Span></P>
                <Button className="button">FINALIZAR TRANSFERÊNCIA</Button>
            </Container>
        </>
    );
}